var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iPhone_X_XS_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone_X_XS_2",
    "data-name": "iPhone X/XS \\u2013 2",
    clipPath: "url(#clip-iPhone_X_XS_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(-616.657 -560.657)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(617 561)",
    fill: "#fc6767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-pdf-solid",
    d: "M12.29,17.3c-.338-1.081-.331-3.169-.135-3.169C12.722,14.134,12.668,16.627,12.29,17.3Zm-.115,3.189a31.175,31.175,0,0,1-1.919,4.236,24.878,24.878,0,0,1,4.25-1.48,8.752,8.752,0,0,1-2.331-2.757ZM5.817,28.923c0,.054.892-.365,2.358-2.716A9.338,9.338,0,0,0,5.817,28.923ZM16.755,10.81h9.188V32.97a1.618,1.618,0,0,1-1.621,1.621H1.621A1.618,1.618,0,0,1,0,32.97V1.621A1.618,1.618,0,0,1,1.621,0H15.134V9.188A1.626,1.626,0,0,0,16.755,10.81Zm-.54,11.607a6.781,6.781,0,0,1-2.885-3.635c.3-1.25.784-3.148.419-4.337a1.692,1.692,0,0,0-3.229-.459c-.338,1.236-.027,2.979.547,5.2a63.443,63.443,0,0,1-2.757,5.8c-.007,0-.007.007-.014.007C6.466,25.93,3.324,28,4.614,29.585a2.1,2.1,0,0,0,1.453.676c1.209,0,2.412-1.216,4.128-4.175a38.511,38.511,0,0,1,5.337-1.567,10.239,10.239,0,0,0,4.324,1.317A1.749,1.749,0,0,0,21.187,22.9C20.248,21.985,17.519,22.248,16.215,22.417ZM25.471,7.094,18.85.473A1.62,1.62,0,0,0,17.7,0H17.3V8.648h8.648V8.236A1.616,1.616,0,0,0,25.471,7.094ZM20.465,24.343c.277-.182-.169-.8-2.892-.608C20.079,24.8,20.465,24.343,20.465,24.343Z",
    transform: "translate(639.401 578.361)",
    fill: "#980000"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf.11e8e7ba.svg";
export { ForwardRef as ReactComponent };